module.exports = __webpack_public_path__ + "img/video_lime.bd758b0f.jpg";